import { ButtonVariant, ButtonSize, type IPeople } from '@/interfaces';
import { useGlobalState } from '@/hooks';
import { PeopleName, PeopleJobPosition } from '../../People.styles';
import { PeopleImage, CustomButton, BorderWrapper, DetailsWrapper } from './Border.styles';

const BorderPeopleComponent: React.FC<IPeople> = ({ image, fullName, profileLink, jobPosition }) => {
  const { getProperImageUrl } = useGlobalState();

  return (
    <BorderWrapper>
      <DetailsWrapper>
        {image?.url && <PeopleImage src={getProperImageUrl(image)} alt={fullName} />}
        <div>
          {fullName && <PeopleName>{fullName}</PeopleName>}
          {jobPosition && <PeopleJobPosition>{jobPosition}</PeopleJobPosition>}
        </div>
      </DetailsWrapper>
      {profileLink && (
        <CustomButton variant={ButtonVariant.Secondary} size={ButtonSize.Medium} href={profileLink}>
          VIEW LINKEDIN
        </CustomButton>
      )}
    </BorderWrapper>
  );
};

export default BorderPeopleComponent;
